import React, { Component } from 'react'
import Main from './routes'
import SiteHeader from './components/headers/site-header'
import Footer from './components/footer'
import './App.css'

class App extends Component {
  render() {
    return (
      <div className="App">
        <SiteHeader />
        <Main />
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js